import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import apiService from "../../../services/api";
import { sortCursos } from "../../../utils/sortFilters";
import { filterBySearchTerm } from "../../../utils/search";
import trashIcon from "../../../assets/trash.png";
import editIcon from "../../../assets/edit.png";
import { usePopup } from "../../common/Popup";

const Outer = styled.div`
  display: flex;
  justify-content: center;
  background: #f9f9f9;
  font-family: public-sans, sans-serif;
`;

const Container = styled.div`
  width: 100%;
`;

const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 60px 0.5fr 0.8fr 0.8fr 0.8fr 160px;
  align-items: center;
  padding-left: 20px;
  height: 50px;
  background: #f2f0f0;
  font-size: 18px;
  font-weight: 700;
  color: #6ab8a8;
  position: sticky;
  top: 0;
  gap: 0;

  > div {
    padding: 0 8px;
    border-right: 1px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    &:last-child {
      border-right: none; !important
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 50px 1fr 0.7fr 0.7fr 0.7fr 140px;
    padding-left: 20px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 40px 1fr 0.6fr 0.6fr 0.6fr 120px;
    padding-left: 15px;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 35px 1.5fr 0.5fr 0.5fr 0.5fr 100px;
    padding-left: 10px;
    font-size: 12px;
  }
`;

const HeaderAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  height: 100%;
  cursor: pointer;

  img {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    img {
      width: 18px;
      height: 18px;
    }
  }

  @media (max-width: 480px) {
    img {
      width: 16px;
      height: 16px;
    }
    gap: 2px;
  }
`;

const HeaderLabel = styled.div`
  font-size: 11px;
  color: #ff9f1f;
`;

const HeaderActionsContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #dfe3e8;
  border-bottom: 1px solid #e6e6e6;
`;

const ListRow = styled.div`
  display: grid;
  grid-template-columns: 60px 0.5fr 0.8fr 0.8fr 0.8fr 160px;
  align-items: center;
  padding-left: 20px;
  height: 50px;
  gap: 0;
  font-size: 16px;
  color: #555555;
  font-weight: 500;
  border-top: 1px solid #e6e6e6;

  &:nth-child(odd) {
    background: #e8f5f3;
  }

  &:nth-child(even) {
    background: #ffffff;
  }

  &:hover {
    background: #f9fefa;
  }

  > div {
    padding: 0 8px;
    border-right: 1px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    &:last-child {
      border-right: none;
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 50px 1fr 0.7fr 0.7fr 0.7fr 140px;
    padding-left: 20px;
    font-size: 15px;
    height: 45px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 40px 1fr 0.6fr 0.6fr 0.6fr 120px;
    padding-left: 15px;
    font-size: 13px;
    height: 40px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 35px 1.5fr 0.5fr 0.5fr 0.5fr 100px;
    padding-left: 10px;
    font-size: 12px;
    height: 35px;
  }
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  cursor: pointer;
  margin-right: 20px;
`;

const InstitutionCell = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 20px; !important
  align-items: center;
  justify-content: flex-start !important;  
  text-align: left !important;     
`;

const LogoWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #6ab8a8;
  color: white;
  font-weight: bold;
  font-size: 12px;
  flex-shrink: 0;
`;

const Actions = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  font-size: 16px;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

const EmptyMessage = styled.div`
  padding: 32px;
  text-align: center;
  color: #555;
  font-size: 15px;
`;

/* ---------- COMPONENT ---------- */

const CursosCadastrados = ({ onEdit, user, sortOrder, searchTerm = '', onCursosChange }) => {
  const popup = usePopup();
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchItems = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = user?.cargoId === 1 
        ? await apiService.getCursos() 
        : await apiService.getMyCursos();
      
      const items = result.data ? result.data : result;
      setItems(items);
      if (onCursosChange) {
        onCursosChange(items.length > 0);
      }
    } catch (err) {
      setError(err.message || "Falha ao carregar");
      if (onCursosChange) {
        onCursosChange(false);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchItems();
    }
  }, [user]);

  const toggleOne = (id) => {
    setSelected((s) => {
      const copy = new Set(s);
      if (copy.has(id)) copy.delete(id);
      else copy.add(id);
      return copy;
    });
  };

  const filteredItems = searchTerm
    ? filterBySearchTerm(items, searchTerm, [
        (curso) => curso.curso,
        (curso) => curso.nome,
      ])
    : items;

  const sortedItems = sortOrder ? sortCursos(filteredItems, sortOrder) : filteredItems;
  const allSelected = sortedItems.length > 0 && selected.size === sortedItems.length;
  
  const toggleAll = () => {
    if (allSelected) setSelected(new Set());
    else setSelected(new Set(sortedItems.map((it) => it.id)));
  };

  const deleteOne = async (id) => {
    const confirmed = await popup.confirm({
      icon: "delete",
      message: "Confirma exclusão deste curso?",
    });
    if (!confirmed) return;
    try {
      await apiService.deleteCurso(id);
      setItems((prev) => {
        const newItems = prev.filter((it) => it.id !== id);
        if (onCursosChange) {
          onCursosChange(newItems.length > 0);
        }
        return newItems;
      });
      setSelected((s) => {
        const c = new Set(s);
        c.delete(id);
        return c;
      });
    } catch (err) {
      await popup.alert({
        icon: "warning",
        message: err.message || "Falha ao deletar",
      });
    }
  };

  const deleteSelected = async () => {
    if (selected.size === 0) return;
    const confirmed = await popup.confirm({
      icon: "delete",
      message: "Confirma exclusão dos selecionados?",
    });
    if (!confirmed) return;
    setBulkLoading(true);
    try {
      const deletePromises = Array.from(selected).map(id => apiService.deleteCurso(id));
      await Promise.all(deletePromises);
      setItems((prev) => {
        const newItems = prev.filter((it) => !selected.has(it.id));
        if (onCursosChange) {
          onCursosChange(newItems.length > 0);
        }
        return newItems;
      });
      setSelected(new Set());
    } catch (err) {
      await popup.alert({
        icon: "warning",
        title: "Erro na exclusão em lote",
        message: err.message || "Tente novamente.",
      });
    } finally {
      setBulkLoading(false);
    }
  };

  const handleEdit = (curso) => {
    sessionStorage.setItem('cursoEditData', JSON.stringify(curso));
    navigate('/CadastroCurso?mode=edit');
  };

  return (
    <Outer>
      <Container>
        <HeaderRow>
          <div>
            <Checkbox
              checked={allSelected}
              onChange={toggleAll}
              aria-label="Selecionar todos"
            />
          </div>
          <div>Curso</div>
          <div>Campis</div>
          <div>Coordenador curso</div>
          <div>Coordenador estágio</div>
          
          <div>
            <HeaderActionsContainer>
              <HeaderAction>
                <img src={editIcon} alt="Editar" />
                <HeaderLabel>Editar</HeaderLabel>
              </HeaderAction>
              
              <HeaderAction 
                onClick={deleteSelected}
                style={{ cursor: "pointer" }}
              >
                <img src={trashIcon} alt="Deletar" />
                <HeaderLabel>
                  {bulkLoading
                    ? "Deletando..."
                    : selected.size > 0
                    ? `${selected.size}`
                    : "Deletar"}
                </HeaderLabel>
              </HeaderAction>
            </HeaderActionsContainer>
          </div>
        </HeaderRow>

        {loading && <EmptyMessage>Carregando...</EmptyMessage>}
        {error && <EmptyMessage>{error}</EmptyMessage>}
        {!loading && sortedItems.length === 0 && (
          <EmptyMessage>Nenhum curso cadastrado.</EmptyMessage>
        )}

        <ListWrapper>
          {sortedItems.map((curso) => (
            <ListRow key={curso.id}>
              <div>
                <Checkbox
                  checked={selected.has(curso.id)}
                  onChange={() => toggleOne(curso.id)}
                />
              </div>
              <InstitutionCell>
                <span>{curso.curso || curso.nome}</span>
              </InstitutionCell>
              <div>{curso.campus || curso.campusNome || curso.campusId || "—"}</div>
              <div>{curso.coordenadorCurso || "—"}</div>
              <div>{curso.coordenadorEstagio || "—"}</div>
              <Actions>
                <IconButton 
                  onClick={() => handleEdit(curso)}
                  title="Editar curso"
                >
                  <img src={editIcon} alt="Editar" style={{ width: 22, height: 22 }} />
                </IconButton>
                <IconButton 
                  onClick={() => deleteOne(curso.id)}
                  title="Deletar curso"
                >
                  <img src={trashIcon} alt="Deletar" style={{ width: 22, height: 22 }} />
                </IconButton>
              </Actions>
            </ListRow>
          ))}
        </ListWrapper>
      </Container>
    </Outer>
  );
};

export default CursosCadastrados;